import { render, staticRenderFns } from "./newInsurance.vue?vue&type=template&id=7f27a855&scoped=true"
import script from "./newInsurance.vue?vue&type=script&lang=js"
export * from "./newInsurance.vue?vue&type=script&lang=js"
import style0 from "./newInsurance.vue?vue&type=style&index=0&id=7f27a855&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f27a855",
  null
  
)

export default component.exports